import MuiFormControlLabel from '@material-ui/core/FormControlLabel';

const FormControlLabel = ({ control, label }) => (
  <MuiFormControlLabel control={ control } label={ label } />
);

export default FormControlLabel;
